/* jshint node:true */
'use strict';

var debug = require('debug')('app:component:Scoreboard');
var React = require('react');
var Router = require('react-router');
var StoreMixin = require('fluxible/addons/FluxibleMixin');
var ESPNhelpersMixin = require('../../mixins/ESPNhelpersMixin');
var loadScoreboard = require('../../actions/loadScoreboard');
var Path = require('../../helpers/utils/path.js');
var Utils = require('../../helpers/utils/index.js');
var browser = require('../../helpers/utils/browser.js');
var ScoreBoard = require('../scoreboard/Index.jsx');
var pollInterval = 30000;

var ScoreboardHandler = React.createClass({

    displayName: 'ScoreboardHandler',

    mixins: [
        Router.State, StoreMixin, ESPNhelpersMixin
    ],

    statics: {
        loadAction: loadScoreboard,
        storeListeners: ['ScoreboardStore', 'HomeStore']
    },

    componentDidMount: function() {
        
    },

    getInitialState: function () {
        return this.getStateFromStores();
    },

    getStateFromStores: function () {
        var scoreBoardStore = this.props.context.getStore('ScoreboardStore');
        var homeStore = this.props.context.getStore('HomeStore');
        var rightColumn = homeStore.getColumn('rightcolumn');
        var scoreboard = scoreBoardStore.getScoreboard();
        var rhs = {
            rhs : { 
                modules : rightColumn.items
            }
        };
        var leagueName;
        if(scoreboard.aggregated){
            leagueName = '';
        }else{
            leagueName = scoreboard.leagues[0].name;
        }
        this._meta.leagueName = leagueName;
        return Utils.Object.assign(scoreboard, rhs);
    },

    onChange: function (store) {
        this.setState(this.getStateFromStores());
    },
    
    componentWillMount: function() {
        this.timer = setInterval(this.poll, pollInterval);
    },
    
    timer: null,
    
    poll: function(){
        var self = this;
        if(location.pathname + location.search === self.getPath()){
            self.props.context.executeAction(loadScoreboard, {
                pathname : self.getPathname(),
                query : self.getQuery(),
                ignoreRHS : true,
                ignoreLeagues: true
            });
        }else {
            clearInterval(self.timer);
            self.timer = null;
        }
    },

    render: function () {
        
        var props = {
            request : Path.decode(this.getPathname()),
            leagues : this.state.leagues,
            aggregated : this.state.aggregated,
            formattedDates: this.state.formattedDates,
            context: this.props.context,
            rhs : this.state.rhs,
            shell : this.props.shell
        };
        
        return (
            <ScoreBoard {...props} />
        );
    }
});

module.exports = ScoreboardHandler;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/handlers/Scoreboard.jsx
 **/